import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {MomentModule} from 'ngx-moment';

import {TimeModule} from '../../+payrolls/prepare/time/time.module';
import {EmployeesSharedModule} from '../../shared/employees/employees-shared.module';
import {ModalModule} from '../../shared/modal/modal.module';
import {PipesModule} from '../../shared/pipes/pipes.module';
import {TeamsSharedModule} from '../../shared/teams/teams-shared.module';
import {UiModule} from '../../shared/ui/ui.module';

import {TeamPlanningComponent} from './team-planning.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ModalModule,
    UiModule,
    ReactiveFormsModule,
    PipesModule,
    TeamsSharedModule,
    MomentModule,
    TranslateModule,
    EmployeesSharedModule,
    TimeModule
  ],
  declarations: [
    TeamPlanningComponent
  ],
  exports: [
    TeamPlanningComponent
  ]
})

export class TeamPlanningModule {
}
